import { auditReports } from '@mi-front/api-clients';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { useIntl } from 'react-intl';

interface Props {
  run: auditReports.AodRun;
  isDisabled: boolean;
  isLoading: boolean;
  executeAction: (promise: Promise<unknown>) => void;
}

export function RefreshRun({ run, isDisabled, isLoading, executeAction }: Props) {
  const { $t } = useIntl();
  const refreshMutation = auditReports.useRefreshAodRunRunActions();

  const handleRefresh = () => {
    executeAction(refreshMutation.mutateAsync({ id: run.id }));
  };

  const isRefreshed = run.userStatus === auditReports.AodRunUserStatusEnum.REFRESHED;

  if (!isRefreshed && !run.canRefresh) {
    return null;
  }

  if (isRefreshed) {
    return null;
  }

  return (
    <Alert severity="info">
      <AlertTitle>
        {$t({
          id: 'audit.aod.actions.refreshRun',
          defaultMessage: 'Actualizar',
        })}
      </AlertTitle>
      <Box display="flex" flexDirection="column" gap={2}>
        <Box>
          {$t({
            id: 'audit.aod.actions.refreshRun.description',
            defaultMessage:
              'Volver a realizar la ejecución con los resultados existentes sin modificar las condiciones de export',
          })}
        </Box>
        <Box>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            startIcon={<RefreshIcon />}
            disabled={isDisabled || !run.id}
            loading={isLoading}
            loadingPosition="start"
            onClick={handleRefresh}
          >
            {$t({
              id: 'audit.aod.actions.refreshRun',
              defaultMessage: 'Actualizar',
            })}
          </Button>
        </Box>
      </Box>
    </Alert>
  );
}
